/**
 * "MCP server" documentation section (ADR-0074).
 * The per-tenant Model Context Protocol server.
 */
import { MCP_AUTH_PAGE } from './pages/mcp-auth.page';
import { MCP_CONNECT_PAGE } from './pages/mcp-connect.page';
import { MCP_OVERVIEW_PAGE } from './pages/mcp-overview.page';
import { MCP_REFERENCE_PAGE } from './pages/mcp-reference.page';
import { MCP_TOOLS_PAGE } from './pages/mcp-tools.page';

import type { DocSection } from './types';

export const MCP_SECTION: DocSection = {
  id: 'mcp',
  titleKey: 'docs.section.mcp.title',
  pages: [MCP_OVERVIEW_PAGE, MCP_CONNECT_PAGE, MCP_AUTH_PAGE, MCP_TOOLS_PAGE, MCP_REFERENCE_PAGE],
};
